import { render, staticRenderFns } from "./Identificacao.vue?vue&type=template&id=74a190d2&scoped=true&"
import script from "./Identificacao.vue?vue&type=script&lang=js&"
export * from "./Identificacao.vue?vue&type=script&lang=js&"
import style0 from "./Identificacao.vue?vue&type=style&index=0&id=74a190d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a190d2",
  null
  
)

export default component.exports